import { Contract, ContractRunner, ethers, InterfaceAbi } from "ethers";
import { DataStore__factory } from "typechain-types/factories/DataStore__factory";
import { ExchangeRouter__factory } from "typechain-types/factories/ExchangeRouter__factory";
import { Multicall__factory } from "typechain-types/factories/Multicall__factory";
import { ARBITRUM, BSC, AVALANCHE_FUJI, BESC, BSС_TESTNET } from "./chains";
import { GlvRouter__factory } from "typechain-types";

const { ZeroAddress } = ethers;

export const XGMT_EXCLUDED_ACCOUNTS = [
  "0x330eef6b9b1ea6edd620c825c9919dc8b611d5d5",
  "0xd9b1c23411adbb984b1c4be515fafc47a12898b2",
  "0xa633158288520807f91ccc98aa58e0ea43acb400",
  "0xffd0a93b4362052a336a7b22494f1b77018dd34b",
];

const CONTRACTS = {
  // [BSС_MAINNET]: {
  //   // bsc mainnet
  //   Treasury: "0xa44E7252a0C137748F523F112644042E5987FfC7",
  //   BUSD: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
  //   GMT: "0x99e92123eB77Bc8f999316f622e5222498438784",
  //   Vault: "0xc73A8DcAc88498FD4b4B1b2AaA37b0a2614Ff67B",
  //   Router: "0xD46B23D042E976F8666F554E928e0Dc7478a8E1f",
  //   Reader: "0x087A618fD25c92B61254DBe37b09E5E8065FeaE7",
  //   AmmFactory: "0xBCfCcbde45cE874adCB698cC183deBcF17952812",
  //   AmmFactoryV2: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
  //   OrderBook: "0x1111111111111111111111111111111111111111",
  //   OrderBookReader: "0x1111111111111111111111111111111111111111",
  //   MoneyMigrator: "0xDEF2af818514c1Ca1A9bBe2a4D45E28f260063f9",
  //   USDG: "0x85E76cbf4893c1fbcB34dCF1239A91CE2A4CF5a7",
  //   NATIVE_TOKEN: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  //   XGMT: "0xe304ff0983922787Fd84BC9170CD21bF78B16B10",
  //   GMT_USDG_PAIR: "0xa41e57459f09a126F358E118b693789d088eA8A0",
  //   XGMT_USDG_PAIR: "0x0b622208fc0691C2486A3AE6B7C875b4A174b317",
  //   GMT_USDG_FARM: "0x3E8B08876c791dC880ADC8f965A02e53Bb9C0422",
  //   XGMT_USDG_FARM: "0x68D7ee2A16AB7c0Ee1D670BECd144166d2Ae0759",
  //   USDG_YIELD_TRACKER: "0x0EF0Cf825B8e9F89A43FfD392664131cFB4cfA89",
  //   XGMT_YIELD_TRACKER: "0x82A012A9b3003b18B6bCd6052cbbef7Fa4892e80",
  //   GMT_USDG_FARM_TRACKER_XGMT: "0x08FAb024BEfcb6068847726b2eccEAd18b6c23Cd",
  //   GMT_USDG_FARM_TRACKER_NATIVE: "0xd8E26637B34B2487Cad1f91808878a391134C5c2",
  //   XGMT_USDG_FARM_TRACKER_XGMT: "0x026A02F7F26C1AFccb9Cba7C4df3Dc810F4e92e8",
  //   XGMT_USDG_FARM_TRACKER_NATIVE: "0x22458CEbD14a9679b2880147d08CA1ce5aa40E84",
  //   AUTO: "0xa184088a740c695E156F91f5cC086a06bb78b827",
  //   AUTO_USDG_PAIR: "0x0523FD5C53ea5419B4DAF656BC1b157dDFE3ce50",
  //   AUTO_USDG_FARM: "0xE6958298328D02051769282628a3b4178D0F3A47",
  //   AUTO_USDG_FARM_TRACKER_XGMT: "0x093b8be41c1A30704De84a9521632f9a139c08bd",
  //   AUTO_USDG_FARM_TRACKER_NATIVE: "0x23ed48E5dce3acC7704d0ce275B7b9a0e346b63A",
  //   GMT_MONEY_IOU: "0x47052469970C2484729875CC9E2dd2683fcE71fb",
  //   XGMT_MONEY_IOU: "0xeB3733DFe3b68C9d26898De2493A3Bb59FDb4A7B",
  //   GMT_USDG_MONEY_IOU: "0x481312655F81b5e249780A6a49735335BF6Ca7f4",
  //   XGMT_USDG_MONEY_IOU: "0x8095F1A92526C304623483018aA28cC6E62EB1e1",
  // },
  [BSС_TESTNET]: {
    // bsc testnet
    Vault: "0x1B183979a5cd95FAF392c8002dbF0D5A1C687D9a",
    Router: "0x10800f683aa564534497a5b67F45bE3556a955AB",
    Reader: "0x98D4742F1B6a821bae672Cd8721283b91996E454",
    AmmFactory: "0x6725f303b657a9451d8ba641348b6761a6cc7a17",
    AmmFactoryV2: "0x1111111111111111111111111111111111111111",
    OrderBook: "0x9afD7B4f0b58d65F6b2978D3581383a06b2ac4e9",
    OrderBookReader: "0x0713562970D1A802Fa3FeB1D15F9809943982Ea9",
    MoneyMigrator: "0xDEF2af818514c1Ca1A9bBe2a4D45E28f260063f9",
    USDG: "0x2D549bdBf810523fe9cd660cC35fE05f0FcAa028",
    GMT: "0xedba0360a44f885ed390fad01aa34d00d2532817",
    NATIVE_TOKEN: "0x612777Eea37a44F7a95E3B101C39e1E2695fa6C2",
    XGMT: "0x28cba798eca1a3128ffd1b734afb93870f22e613",
    GMT_USDG_PAIR: "0xe0b0a315746f51932de033ab27223d85114c6b85",
    XGMT_USDG_PAIR: "0x0108de1eea192ce8448080c3d90a1560cf643fa0",
    GMT_USDG_FARM: "0xbe3cB06CE03cA692b77902040479572Ba8D01b0B",
    XGMT_USDG_FARM: "0x138E92195D4B99CE3618092D3F9FA830d9A69B4b",
    USDG_YIELD_TRACKER: "0x62B49Bc3bF252a5DB26D88ccc7E61119e3179B4f",
    XGMT_YIELD_TRACKER: "0x5F235A582e0993eE9466FeEb8F7B4682993a57d0",
    GMT_USDG_FARM_TRACKER_XGMT: "0x4f8EE3aE1152422cbCaFACd4e3041ba2D859913C",
    GMT_USDG_FARM_TRACKER_NATIVE: "0xd691B26E544Fe370f39A776964c991363aF72e56",
    XGMT_USDG_FARM_TRACKER_XGMT: "0xfd5617CFB082Ba9bcD62d654603972AE312bC695",
    XGMT_USDG_FARM_TRACKER_NATIVE: "0x0354387DD85b7D8aaD1611B3D167A384d6AE0c28",
    GMT_MONEY_IOU: "0x47052469970C2484729875CC9E2dd2683fcE71fb",
    XGMT_MONEY_IOU: "0xeB3733DFe3b68C9d26898De2493A3Bb59FDb4A7B",
    GMT_USDG_MONEY_IOU: "0x481312655F81b5e249780A6a49735335BF6Ca7f4",
    XGMT_USDG_MONEY_IOU: "0x8095F1A92526C304623483018aA28cC6E62EB1e1",
  },
  [ARBITRUM]: {
    // arbitrum mainnet
    Vault: "0x489ee077994B6658eAfA855C308275EAd8097C4A",
    Router: "0xaBBc5F99639c9B6bCb58544ddf04EFA6802F4064",
    VaultReader: "0xfebB9f4CAC4cD523598fE1C5771181440143F24A",
    Reader: "0x2b43c90D1B727cEe1Df34925bcd5Ace52Ec37694",
    MlpManager: "0x3963FfC9dff443c2A94f21b129D429891E32ec18",
    RewardRouter: "0x5E4766F932ce00aA4a1A82d3Da85adf15C5694A1",
    MlpRewardRouter: "0xB95DB5B167D75e6d04227CfFFA61069348d271F5",
    RewardReader: "0x8BFb8e82Ee4569aee78D03235ff465Bd436D40E0",
    GovToken: "0x2A29D3a792000750807cc401806d6fd539928481",
    NATIVE_TOKEN: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    MLP: "0x4277f8F2c384827B5273592FF7CeBd9f2C1ac258",
    MONEY: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
    ES_MONEY: "0xf42Ae1D54fd613C9bb14810b0588FaAa09a426cA",
    BN_MONEY: "0x35247165119B69A40edD5304969560D0ef486921",
    USDG: "0x45096e7aA921f27590f8F19e457794EB09678141",
    ES_MONEY_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954",
    StakedMoneyTracker: "0x908C4D94D34924765f1eDc22A1DD098397c59dD4",
    BonusMoneyTracker: "0x4d268a7d4C16ceB5a606c173Bd974984343fea13",
    FeeMoneyTracker: "0xd2D1162512F927a7e282Ef43a362659E4F2a728F",
    StakedMlpTracker: "0x1aDDD80E6039594eE970E5872D247bf0414C8903",
    FeeMlpTracker: "0x4e971a87900b931fF39d1Aad67697F49835400b6",
    ExtendedMoneyTracker: "0x0755D33e45eD2B874c9ebF5B279023c8Bd1e5E93",

    StakedMoneyDistributor: "0x23208B91A98c7C1CD9FE63085BFf68311494F193",
    StakedMlpDistributor: "0x60519b48ec4183a61ca2B8e37869E675FD203b34",

    MoneyVester: "0x199070DDfd1CFb69173aa2F7e20906F26B363004",
    MlpVester: "0xA75287d2f8b217273E7FCD7E86eF07D33972042E",
    AffiliateVester: "0x7c100c0F55A15221A4c1C5a25Db8C98A81df49B2",

    OrderBook: "0x09f77E8A13De9a35a7231028187e9fD5DB8a2ACB",
    OrderExecutor: "0x7257ac5D0a0aaC04AA7bA2AC0A6Eb742E332c3fB",
    OrderBookReader: "0xa27C20A7CF0e1C68C0460706bB674f98F362Bc21",

    PositionRouter: "0xb87a436B93fFE9D75c5cFA7bAcFff96430b09868",
    PositionManager: "0x75E42e6f01baf1D6022bEa862A28774a9f8a4A0C",

    UniswapMoneyEthPool: "0x80A9ae39310abf666A87C743d6ebBD0E8C42158E",
    ReferralStorage: "0xe6fab3f0c7199b0d34d7fbe83394fc0e0d06e99d",
    ReferralReader: "0x8Aa382760BCdCe8644C33e6C2D52f6304A76F5c8",
    Timelock: "0xaa50bD556CE0Fe61D4A57718BA43177a3aB6A597",

    // Synthetics
    DataStore: "0xFD70de6b91282D8017aA4E741e9Ae325CAb992d8",
    EventEmitter: "0xC8ee91A54287DB53897056e12D9819156D3822Fb",
    SubaccountRouter: "0xa329221a77BE08485f59310b873b14815c82E10D",
    ExchangeRouter: "0x900173A66dbD345006C51fA35fA3aB760FcD843b",
    DepositVault: "0xF89e77e8Dc11691C9e8757e84aaFbCD8A67d7A55",
    WithdrawalVault: "0x0628D46b5D145f183AdB6Ef1f2c97eD1C4701C55",
    OrderVault: "0x31eF83a530Fde1B38EE9A18093A333D8Bbbc40D5",
    ShiftVault: "0xfe99609C4AA83ff6816b64563Bdffd7fa68753Ab",
    SyntheticsReader: "0x0537C767cDAC0726c76Bb89e92904fe28fd02fE1",
    SyntheticsRouter: "0x7452c558d45f8afC8c83dAe62C3f8A5BE19c71f6",

    GlvReader: "0x6a9505D0B44cFA863d9281EA5B0b34cB36243b45",
    GlvRouter: "0x105b5aFe50FBCe7759051974fB1710ce331C77B3",
    GlvVault: "0x393053B58f9678C9c28c2cE941fF6cac49C3F8f9",

    Multicall: "0x842ec2c7d803033edf55e478f461fc547bc54eb2",
  },
  [BSC]: {
    // bsc
    Vault: "0xeB0E5E1a8500317A1B8fDd195097D5509Ef861de",
    Router: "0x301018DAA6788775b4A500ef3228dB14E0d6A5a7",
    VaultReader: "0x3f033207dDb0eDf06A474990c1750ee7900E7776",
    Reader: "0x0963B6D4dE8F492c5ea0F37Fef4ABdc723Eb7A40",
    MlpManager: "0x667e43E32372696c27B7AB72D435bC9261F35E01",
    RewardRouter: "0xA92eaE4AB17f9091FBf5dA7C7cbB0AEa346649C9",
    MlpRewardRouter: "0xA92eaE4AB17f9091FBf5dA7C7cbB0AEa346649C9",
    RewardReader: "0xa8433BC9DcB49875d218A15eF1d6AAC4D0076C8A",
    GovToken: "0x0ff183E29f1924ad10475506D7722169010CecCb",
    NATIVE_TOKEN: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    MLP: "0x14C7E28d4Dd0D593cB2D481a7CBaF462b18a477a",
    MONEY: "0x4fFe5ec4D8B9822e01c9E49678884bAEc17F60D9",
    ES_MONEY: "0x4768232700c2f81721fA94822535d35c2354633B",
    BN_MONEY: "0x59B2f533928222feFf104f2FD1a1d0CE652C1718",
    USDG: "0x4925C7e05347d90A3c7e07f8D8b3A52FaAC91bCb",
    ES_MONEY_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954", // placeholder address

    StakedMoneyTracker: "0xEB445ac93eDc6F91E69CA35674CEbE9CC96CFEaB",
    BonusMoneyTracker: "0x8Bb13A67be7d9ea51cA74327bC81807D1461403D",
    FeeMoneyTracker: "0xeBBc55644c9bD5095a0eA0Ea64ac92Fb60E0B5fB",
    StakedMlpTracker: "0x98bBB86BE5716159aCbEE84B0B38Eb0F246dC8fC",
    FeeMlpTracker: "0x3BED1168119334d2e4d9aB0CC67dE7CCf4EFE561",
    ExtendedMoneyTracker: "0xB0D12Bf95CC1341d6C845C978daaf36F70b5910d", //Unused for my GMX V1

    StakedMoneyDistributor: "0x6f552E4061d2D255C6b32e96D597De3F2EaC7E6f",
    StakedMlpDistributor: "0xC964FEf4e161e2D1E0c2F6C6C4F0bcfcCB2AD8b2",

    MoneyVester: "0xe3394F30568D36593147c93Cce75cc497319C99D",
    MlpVester: "0xaCD327e3ec595F601C6c7b02585c3db01E6A2a09",
    AffiliateVester: "0x754eC029EF9926184b4CFDeA7756FbBAE7f326f7",

    OrderBook: "0x6b448DF5a0E6BcA35e76e50D9CD53BEA3caa7efa",
    OrderExecutor: "0x4296e307f108B2f583FF2F7B7270ee7831574Ae5",
    OrderBookReader: "0x07862C2F85fb0A21CB3Cb0A71623Ec4F2a026b22",

    PositionRouter: "0x065F9746b33F303c6481549BAc42A3885903fA44",
    PositionManager: "0x62dEFAA710dcd1dA4d9231E1EED1fb16c2278CCF",

    TraderJoeBescBscPool: "0x489769805809d4f5F5B0aF34D57E32Be73a8e7D0",
    TraderJoeMoneyBscPool: "0x1c8fc4506930ed7a58187c8A9E77cB0309c349B8",
    ReferralStorage: "0xA833940Ed3c260C2d603ad9d9152E2533D6005DF",
    ReferralReader: "0xC8b438204D9C97f367A7039e06F8C266E2b22738",
    Timelock: "0x0cb8cf2EdccD329cEba9176D588A2B895a20ba3A",

    // Copy Trading (addresses set after deployment — update deploy-bsc.json)
    CopyTradingStorage: "0x0000000000000000000000000000000000000000",
    CopyTradingManager: "0x0000000000000000000000000000000000000000",

    // Synthetics
    DataStore: "0x2F0b22339414ADeD7D5F06f9D604c7fF5b2fe3f6",
    EventEmitter: "0xDb17B211c34240B014ab6d61d4A31FA0C0e20c26",
    SubaccountRouter: "0x5aEb6AD978f59e220aA9099e09574e1c5E03AafD",
    ExchangeRouter: "0x2b76df209E1343da5698AF0f8757f6170162e78b",
    DepositVault: "0x90c670825d0C62ede1c5ee9571d6d9a17A722DFF",
    WithdrawalVault: "0xf5F30B10141E1F63FC11eD772931A8294a591996",
    OrderVault: "0xD3D60D22d415aD43b7e64b510D86A30f19B1B12C",
    ShiftVault: "0x7fC46CCb386e9bbBFB49A2639002734C3Ec52b39",
    SyntheticsReader: "0x618fCEe30D9A26e8533C3B244CAd2D6486AFf655",
    SyntheticsRouter: "0x820F5FfC5b525cD4d88Cd91aCf2c28F16530Cc68",

    GlvReader: "0xae9596a1C438675AcC75f69d32E21Ac9c8fF99bD",
    GlvRouter: "0x6BE75346C0262015E45c6fC0e3268BBa73e87D1a",
    GlvVault: "0x527FB0bCfF63C47761039bB386cFE181A92a4701",

    Multicall: "0xcA11bde05977b3631167028862bE2a173976CA11",
  },

  [BESC]: {
    // ── Deployed on BESC Hyperchain (chainId 2372) ────────────────────────────
    NATIVE_TOKEN: "0x33e22F85CC1877697773ca5c85988663388883A0", // WBESC
    MONEY:        "0xf794E0B0c0a91099ccAcac296193e04Fb860442a",
    Multicall:    "0x6dE3F6ae5a7Ba67Ec2cD12703a6Ce6F10Ca5EfEa",

    // Core
    // NOTE: liquidity is consolidated into SynthVault. The MLP token + manager
    // are the Synth ones (single pool: BUSDC + WBESC + MONEY). The RewardRouter
    // was re-initialized on-chain to mint/redeem SynthMLP via SynthMlpManager.
    Vault:        "0xA5c71472b38afBd39cA5a0bBFBa5374CaEE03a2A",
    Router:       "0x53b6C33Ba013594C1D12731FBce4Ae81cC348468",
    VaultReader:  "0x041F48A65d7C1a8f676c3A882043e8f46EB9B7C9",
    Reader:       "0x4556ac6716D44E7EEad2d64486d88C073f2D96D0",
    MlpManager:   "0x3ccF047bEfDb42BA90544f0eA78f3B4fcDCb1b23", // SynthMlpManagerV2 (multi-token LP)
    RewardReader: "0x4304709155a34D760f31a557D6012c93F6b6078b",
    MLP:          "0xFc80AF0eA8d75b34f52357310dFf81E47d6b08a0", // SynthMLP (was 0xE0A08B2F)
    USDG:         "0x4368847c8c142Dd0077018629D27A47B9247E4D3", // SynthUSDG (was 0x723aD9aB)

    // Staking
    RewardRouter:    "0x4EF6234261a112715c1f6D647d1873F1ad4d478C", // RewardRouterV2
    MlpRewardRouter: "0x4EF6234261a112715c1f6D647d1873F1ad4d478C",
    ES_MONEY:        "0xD26c352bb72308042cC069Bc432078bB5D9409c9", // EsMONEY
    BN_MONEY:        "0xFB5E22863Ee836614d28F0E2f263deA015640fE8", // BonusMONEY
    ES_MONEY_IOU:    ZeroAddress,

    StakedMoneyTracker:   "0x01ACB2d15B5F034796FaA95451c591b28132FA9d", // RewardTrackerStakedMONEY (sMONEY)
    BonusMoneyTracker:    "0x9F325D23D06d53ac26FDD26427374886b633FfF7", // RewardTrackerStakedBonusMONEY (sbMONEY)
    FeeMoneyTracker:      "0x86bd10E06fda062aa743A14C53Be22CA304eFb25", // RewardTrackerStakedBonusFeeMONEY (sbfMONEY)
    StakedMlpTracker:     "0x7D54031695509FddBf76D80252AcC8f76deA4224", // RewardTrackerFeeStakedMLP (fsMLP)
    FeeMlpTracker:        "0xF251e5E2086046F8397BC521a38a6242eDfD6C94", // RewardTrackerFeeMLP (fMLP)
    ExtendedMoneyTracker: ZeroAddress,

    StakedMoneyDistributor: "0x840E64Ea4AF07aBCB13626054105A0f6378cFeA9", // RewardDistributorStakedMONEY
    StakedMlpDistributor:   "0xd864e1A1982170f25100Bfbd04E367E660afE0Df", // RewardDistributorFeeStakedMLP

    MoneyVester:     "0x8c35409c69835E5f814e4d693d957af95Fc7F356",
    MlpVester:       "0x1ac51155569d30aB1a65D702e2f67554e3E21f92",
    AffiliateVester: ZeroAddress,

    // Trading
    OrderBook:       "0x9e47F6f5Acf48850a05a9f78dB14212495186E77",
    OrderExecutor:   "0xe7cB7E1A2087A5990E1F56DCB211c867b4a53467", // PositionManager
    OrderBookReader: "0xD3250eBed7c0B21FF878b16F8Ae6D90552A547D4",
    PositionRouter:  "0x86e39a9908A3E92AEa48F4a1b6A9258935383507",
    PositionManager: "0xe7cB7E1A2087A5990E1F56DCB211c867b4a53467",

    // Referrals
    ReferralStorage: "0x8E5aBc8C223a7D7517913005F9f624D6479F762A",
    ReferralReader:  "0x22A10B3c7A5b7BA23A85a3b18095Aa048b7c9120",
    Timelock:        ZeroAddress,

    // SynthVault — BUSDC-only pool for synthetic long/short markets
    SynthVault:           "0xdB15dF10C2203291D9Fa218b487f924C3B017d6E",
    SynthRouter:          "0xD4BF1ffC2151a0cfd145be4B3Ecb535E005f8E53",
    SynthPositionRouter:  "0xbA9Fb6386D4d0A033D5f14e3032b1E82e1A1b34f",
    SynthShortsTracker:   "0x72635D2D42D3292c8118C9e6A68a105E8dAD260A",
    SynthMlpManager:      "0x3ccF047bEfDb42BA90544f0eA78f3B4fcDCb1b23",
    SynthVaultPriceFeed:  "0xBCA974d8426680e530682ba2c4E9f72e159e2aa9",
    SynthMLP:             "0xFc80AF0eA8d75b34f52357310dFf81E47d6b08a0",
    SynthUSDG:            "0x4368847c8c142Dd0077018629D27A47B9247E4D3",

    // Copy trading
    CopyTradingStorage: "0xf330224aAdFfC2b7c48091eA5fb7702C7c61c339",
    CopyTradingManager: "0x7c2354BAC8a4BEAbBd645c710761fB555cDC94ac",

    // V2 / Synthetics — not deployed on BESC (V1 only)
    DataStore:        ZeroAddress,
    EventEmitter:     ZeroAddress,
    SubaccountRouter: ZeroAddress,
    ExchangeRouter:   ZeroAddress,
    DepositVault:     ZeroAddress,
    WithdrawalVault:  ZeroAddress,
    OrderVault:       ZeroAddress,
    ShiftVault:       ZeroAddress,
    SyntheticsReader: ZeroAddress,
    SyntheticsRouter: ZeroAddress,
    GlvReader:        ZeroAddress,
    GlvRouter:        ZeroAddress,
    GlvVault:         ZeroAddress,
  },

  [AVALANCHE_FUJI]: {
    Vault: ZeroAddress,
    Router: ZeroAddress,
    VaultReader: ZeroAddress,
    Reader: ZeroAddress,
    MlpManager: ZeroAddress,
    RewardRouter: ZeroAddress,
    RewardReader: ZeroAddress,
    MlpRewardRouter: ZeroAddress,
    NATIVE_TOKEN: "0x1D308089a2D1Ced3f1Ce36B1FcaF815b07217be3",
    MLP: ZeroAddress,
    MONEY: ZeroAddress,
    ES_MONEY: ZeroAddress,
    BN_MONEY: ZeroAddress,
    USDG: ZeroAddress,
    ES_MONEY_IOU: ZeroAddress,

    StakedMoneyTracker: ZeroAddress,
    BonusMoneyTracker: ZeroAddress,
    FeeMoneyTracker: ZeroAddress,
    StakedMlpTracker: ZeroAddress,
    FeeMlpTracker: ZeroAddress,
    ExtendedMoneyTracker: ZeroAddress,

    StakedMoneyDistributor: ZeroAddress,
    StakedMlpDistributor: ZeroAddress,

    MoneyVester: ZeroAddress,
    MlpVester: ZeroAddress,
    AffiliateVester: ZeroAddress,

    OrderBook: ZeroAddress,
    OrderExecutor: ZeroAddress,
    OrderBookReader: ZeroAddress,

    PositionRouter: ZeroAddress,
    PositionManager: ZeroAddress,

    TraderJoeMoneyBscPool: ZeroAddress,
    ReferralStorage: "0x58726dB901C9DF3654F45a37DD307a0C44b6420e",
    ReferralReader: ZeroAddress,

    // Synthetics
    DataStore: "0xEA1BFb4Ea9A412dCCd63454AbC127431eBB0F0d4",
    EventEmitter: "0xc67D98AC5803aFD776958622CeEE332A0B2CabB9",
    ExchangeRouter: "0x52A1c10c462ca4e5219d0Eb4da5052cc73F9050D",
    SubaccountRouter: "0x0595f01860aa5c4C6091EED096515b4b9FE372CE",
    DepositVault: "0x2964d242233036C8BDC1ADC795bB4DeA6fb929f2",
    WithdrawalVault: "0x74d49B6A630Bf519bDb6E4efc4354C420418A6A2",
    OrderVault: "0x25D23e8E655727F2687CC808BB9589525A6F599B",
    ShiftVault: "0x257D0EA0B040E2Cd1D456fB4C66d7814102aD346",
    SyntheticsReader: "0x16Fb5b8846fbfAe09c034fCdF3D3F9492484DA80",
    SyntheticsRouter: "0x5e7d61e4C52123ADF651961e4833aCc349b61491",
    Timelock: ZeroAddress,

    GlvReader: "0x4599Ed5939C673505B7AFcd020E1d603b0dCAf69",
    GlvRouter: "0x377d979AB35Cd848497707ffa6Ee91783f925b80",
    GlvVault: "0x76f93b5240DF811a3fc32bEDd58daA5784e46C96",

    Multicall: "0x0f53e512b49202a37c81c6085417C9a9005F2196",
  },
};

export function getContract(chainId: number, name: string): string {
  if (!CONTRACTS[chainId]) {
    throw new Error(`Unknown chainId ${chainId}`);
  }

  if (!CONTRACTS[chainId][name]) {
    throw new Error(`Unknown contract "${name}" for chainId ${chainId}`);
  }

  return CONTRACTS[chainId][name];
}

// Address of the LIVE V1 vault for pool/token/fee/weight reads. On BESC the
// old "Vault" is retired (stale poolAmounts); the live pool is SynthVault.
// NOTE: this is for display/state reads only — the Exchange position path
// intentionally keeps its own main-vs-synth split, so do not use this there.
export function getV1VaultAddress(chainId: number): string {
  if (chainId === BESC) {
    try {
      return getContract(chainId, "SynthVault");
    } catch (_) {
      /* fall through to Vault */
    }
  }
  return getContract(chainId, "Vault");
}

function makeGetContract<T extends { abi: InterfaceAbi; connect: (address: string) => unknown }>(
  name: string,
  factory: T
) {
  return (chainId: number, provider?: ContractRunner) =>
    new Contract(getContract(chainId, name), factory.abi, provider) as unknown as ReturnType<T["connect"]>;
}

export const getDataStoreContract = makeGetContract("DataStore", DataStore__factory);
export const getMulticallContract = makeGetContract("Multicall", Multicall__factory);
export const getExchangeRouterContract = makeGetContract("ExchangeRouter", ExchangeRouter__factory);
export const getGlvRouterContract = makeGetContract("GlvRouter", GlvRouter__factory);

export const getZeroAddressContract = (provider?: ContractRunner) => new Contract(ZeroAddress, [], provider);

export function tryGetContract(chainId: number, name: string): string | undefined {
  return CONTRACTS[chainId]?.[name];
}
